import React from 'react';
import { motion } from 'framer-motion';
export function Hero() {
  const handleBooking = () => {
    window.open('https://studiomery.koob.uy', '_blank', 'noopener,noreferrer');
  };
  const handleServices = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    const element = document.querySelector('#servicios');
    if (element) {
      const offsetTop = element.getBoundingClientRect().top + window.scrollY - 80;
      window.scrollTo({
        top: offsetTop,
        behavior: 'smooth'
      });
    }
  };
  return <section id="inicio" className="relative bg-cream" data-id="element-108">
      {/* Banner Image (top of page) */}
      <div className="w-full overflow-hidden" data-id="element-109">
        <img src="https://cdn.magicpatterns.com/uploads/hhAuaR2HbARqwPmdRYwUd3/banner_2.png" alt="Studio by Mery — Nails & Eyelashes" className="w-full h-auto object-cover object-center" data-id="element-110" />
      </div>

      {/* Content band below the banner */}
      <div className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 md:py-20" data-id="element-111">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="max-w-3xl mx-auto text-center" data-id="element-112">
          <span className="block text-rosegold font-medium tracking-widest uppercase text-sm mb-4" data-id="element-113">
            Punta Carretas, Montevideo
          </span>
          <h1 className="text-3xl md:text-4xl lg:text-5xl font-serif text-charcoal leading-tight mb-6" data-id="element-114">
            Tu espacio de belleza y bienestar en Punta Carretas
          </h1>
          <p className="text-lg md:text-xl text-charcoal-light font-light mb-10 max-w-xl mx-auto leading-relaxed" data-id="element-115">
            Una experiencia premium diseñada para resaltar tu mejor versión.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-116">
            <button onClick={handleBooking} className="bg-rosegold text-white px-8 py-3.5 rounded-full font-medium hover:bg-rosegold-dark transition-all duration-300 shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 text-center" data-id="element-117">
              Reservá tu turno
            </button>
            <a href="#servicios" onClick={handleServices} className="border border-charcoal/40 text-charcoal px-8 py-3.5 rounded-full font-medium hover:bg-charcoal hover:text-white hover:border-charcoal transition-all duration-300 text-center" data-id="element-118">
              Conocé nuestros servicios
            </a>
          </div>
        </motion.div>
      </div>
    </section>;
}